import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import { ChromePicker } from 'react-color';
import DAO from '../dao/DAO';
import { CountryRegionData } from 'react-country-region-selector-material-ui-new';
import MenuItem from '@material-ui/core/MenuItem';
import AdminPortalDropdown from './AdminPortalDropdown';
import InputAdornment from '@material-ui/core/InputAdornment';

export const AdminPortalTextField = withStyles({
  root: {
    marginRight: 8,
    '& .MuiInputBase-root.Mui-disabled': {
      color: 'rgba(0, 0, 0, 1)',
    },
  }
})(TextField);

export const WEIGHT = [ 'pounds', 'kilograms' ];
export const HEIGHT = [ 'inches', 'centimeters', 'meters' ];
const COACHING_LEVELS = [ 'High School', 'AAU', 'Collegiate', 'International' ];
const HIGH_SCHOOL = [ 'Varsity', 'Junior Varsity', 'Other' ];
const AAU = [ 'Nike EYBL', 'Adidas Gauntlet', 'Under Armour Association', 'Other' ];
const COLLEGIATE = [ 'NCAA - Division I', 'NCAA - Division II', 'NCAA - Division III', 'NCAA - JUCO', 'NAIA', 'Other' ];
const INTERNATIONAL = [ 'Amateur', 'Semi-Pro', 'Professional' ];
const TEAM_GENDER = [ 'Male', 'Female' ];
const TITLE = [ 'Head Coach', 'Assistant Coach', 'General Manager', 'Front Office', 'Other' ];
const YEARS_COACHING = [ '1-3 Years', '4-6 Years', '7-10 Years', '10+ Years' ];

const EMPTY_STATE = {
  newStateError: false,
  newCityError: false,
  newTeamNameError: false,
  newTeamLogo: '',
  newPrimaryColor: '',
  newSecondaryColor: '',
  newTeamName: '',
  newTeamAbbr: '',
  newTeamNick: '',
  newCountry: '',
  newCity: '',
  newState: '',
  newWeightUnit: '',
  newHeightUnit: '',
  newTeamGender: '',
  newCoachTitle: '',
  newCoachingYears: '',
  newCoachingLevel: '',
  newCoachingLevelHighSchool: '',
  newCoachingLevelAAU: '',
  newCoachingLevelCollegiate: '',
  newCoachingLevelInternational: '',
};

class ConsumerAccountProperties extends Component {

  static contextTypes = {
    dao: PropTypes.instanceOf(DAO),
    ngUser: PropTypes.object,
    onError: PropTypes.func,
    onSuccess: PropTypes.func,
  };

  static propTypes = {
    accountSummary: PropTypes.object,
    isEditing: PropTypes.bool.isRequired,
  }

  state = {
    ...EMPTY_STATE,
  }

  componentDidMount() {
    this.updateStateProperties(this.props);
  }

  componentWillReceiveProps(nextProps: Readonly<P>, nextContext: any) {
    const { isEditing, enableEditMode, onSave } = this.props;
    const { onError } = this.context;
    if (isEditing === false && nextProps.isEditing === true) {
      if (this.requiredFieldsCompletedCheck()) {
        const account = this.bundleAccount();
        this.setState({ ...EMPTY_STATE }, onSave(account));
      } else {
        onError('Please fill in the required fields.');
        enableEditMode();
      }
    } else {
      this.updateStateProperties(nextProps);
    }
  }

  updateStateProperties(props) {
    const weightUnit = this.fetchAccountProperty(props, 'weight_unit');
    const heightUnit = this.fetchAccountProperty(props, 'height_unit');
    const newWeightUnit = weightUnit === '' ? 'pounds' : weightUnit;
    const newHeightUnit = heightUnit === '' ? 'inches' : heightUnit;
    const newCityError = this.fetchAccountProperty(props, 'city') === '';
    const newStateError = this.fetchAccountProperty(props, 'state') === '';
    const newTeamNameError = this.fetchAccountProperty(props, 'team_name') === '';
    this.setState({
      newCityError,
      newStateError,
      newTeamNameError,
      newTeamName: this.fetchAccountProperty(props, 'team_name'),
      newTeamLogo: this.fetchAccountProperty(props, 'team_logo'),
      newPrimaryColor: this.fetchAccountProperty(props, 'primary_color'),
      newSecondaryColor: this.fetchAccountProperty(props, 'secondary_color'),
      newTeamAbbr: this.fetchAccountProperty(props, 'team_abbr'),
      newTeamNick: this.fetchAccountProperty(props, 'team_nick'),
      newCountry: this.fetchAccountProperty(props, 'country'),
      newCity: this.fetchAccountProperty(props, 'city'),
      newState: this.fetchAccountProperty(props, 'state'),
      newTeamGender: this.fetchAccountProperty(props, 'team_gender'),
      newCoachTitle: this.fetchAccountProperty(props, 'coach_title'),
      newCoachingYears: this.fetchAccountProperty(props, 'coach_years'),
      newCoachingLevel: this.fetchAccountProperty(props, 'coach_level'),
      newCoachingLevelHighSchool: this.fetchAccountProperty(props, 'coach_level_hs'),
      newCoachingLevelAAU: this.fetchAccountProperty(props, 'coach_level_aau'),
      newCoachingLevelCollegiate: this.fetchAccountProperty(props, 'coach_level_collegiate'),
      newCoachingLevelInternational: this.fetchAccountProperty(props, 'coach_level_international'),
      newWeightUnit,
      newHeightUnit,
    });
  }

  bundleAccount() {
    const {
      newTeamName, newTeamLogo, newPrimaryColor, newSecondaryColor, newTeamAbbr, newTeamNick, newCountry, newCity,
      newState, newTeamGender, newCoachTitle, newCoachingYears, newCoachingLevel, newCoachingLevelHighSchool,
      newCoachingLevelAAU, newCoachingLevelCollegiate, newCoachingLevelInternational, newWeightUnit, newHeightUnit
    } = this.state;
    return {
      ...this.props.accountSummary,
      team_name: newTeamName,
      team_logo: newTeamLogo,
      primary_color: newPrimaryColor,
      secondary_color: newSecondaryColor,
      team_abbr: newTeamAbbr,
      team_nick: newTeamNick,
      country: newCountry,
      city: newCity,
      state: newState,
      team_gender: newTeamGender,
      coach_title: newCoachTitle,
      coach_years: newCoachingYears,
      coach_level: newCoachingLevel,
      coach_level_hs: newCoachingLevelHighSchool,
      coach_level_aau: newCoachingLevelAAU,
      coach_level_collegiate: newCoachingLevelCollegiate,
      coach_level_international: newCoachingLevelInternational,
      height_unit: newHeightUnit,
      weight_unit: newWeightUnit,
    };
  }

  requiredFieldsCompletedCheck() {
    const { newCountry, newTeamNameError, newCityError, newStateError } = this.state;
    if (newTeamNameError || newCityError || newStateError) {
      return false;
    }
    return newCountry !== '';
  }

  handleRequiredFields = (e) => {
    if (e.target.value === '') {
      this.setState({
        [ `${e.target.id}Error` ]: true,
        [ e.target.id ]: ''
      });
    } else {
      this.setState({
        [ `${e.target.id}Error` ]: false,
        [ e.target.id ]: e.target.value
      });
    }
  };

  handleSelectedDropdown = (e) => {
    this.setState({
      [ e.target.name ]: e.target.value
    });
  }

  handleCoachingLevelSelectedDropdown = (e) => {
    const newCoachingLevelHighSchool = '';
    const newCoachingLevelAAU = '';
    const newCoachingLevelCollegiate = '';
    const newCoachingLevelInternational = '';
    this.setState({
      newCoachingLevelHighSchool,
      newCoachingLevelAAU,
      newCoachingLevelCollegiate,
      newCoachingLevelInternational,
      [ e.target.name ]: e.target.value
    });
  }

  handleNormalFields = (e) => {
    this.setState({
      [ e.target.id ]: e.target.value
    });
  };

  handleTextFieldsOnChange = (e) => {
    this.setState({
      [ e.target.id ]: e.target.value
    });
  }

  fetchAccountProperty(props, key) {
    const { accountSummary } = props;
    if (accountSummary !== undefined) {
      const property = accountSummary[ key ];
      return property || '';
    } else {
      return '';
    }
  }

  handlePrimaryColorChange = (color) => {
    this.setState({ newPrimaryColor: color.hex.replace('#', '') });
  };

  handleSecondaryColorChange = (color) => {
    this.setState({ newSecondaryColor: color.hex.replace('#', '') });
  };

  handleSelectFile = e => {
    if (e.target && e.target.files && !e.target.files.length) return;
    const { dao } = this.context;
    const file = e.target.files[ 0 ];

    let requestData = {
      fileName: file.fileName,
      length: file.size,
      duration: 0,
      app: 'AdminPortal',
      previewLength: 0,
    };

    let formData = new FormData();
    formData.append('file', file);
    formData.append('uploadRequest', JSON.stringify(requestData));

    dao.media.uploadImage(formData).then((resp) => {
      this.setState({
        newTeamLogo: resp.s3Reference.url
      });
    });
  };

  fetchCoachingLevelOptions() {
    switch (this.state.newCoachingLevel) {
      case 'High School':
        return HIGH_SCHOOL;
      case 'AAU':
        return AAU;
      case 'Collegiate':
        return COLLEGIATE;
      case 'International':
        return INTERNATIONAL;
      default:
        return [];
    }
  }

  fetchCoachingLevelValue() {
    switch (this.state.newCoachingLevel) {
      case 'High School':
        return this.state.newCoachingLevelHighSchool;
      case 'AAU':
        return this.state.newCoachingLevelAAU;
      case 'Collegiate':
        return this.state.newCoachingLevelCollegiate;
      case 'International':
        return this.state.newCoachingLevelInternational;
      default:
        return '';
    }
  }

  fetchCoachingLevelId() {
    switch (this.state.newCoachingLevel) {
      case 'High School':
        return 'newCoachingLevelHighSchool';
      case 'AAU':
        return 'newCoachingLevelAAU';
      case 'Collegiate':
        return 'newCoachingLevelCollegiate';
      case 'International':
        return 'newCoachingLevelInternational';
      default:
        return '';
    }
  }


  render() {
    const { accentColor, isEditing, } = this.props;
    const {
      newSecondaryColor, newPrimaryColor, newTeamLogo, newTeamName, newTeamNick, newTeamAbbr, newWeightUnit,
      newHeightUnit, newCity, newState, newCountry, newCoachingYears, newCoachTitle, newTeamGender, newCoachingLevel
    } = this.state;
    return (
      <div className="full-width">
        <header className="full-width mg-sm futura-pt-bold" style={{ fontSize: 20 }}>Basic Information</header>
        <div className="display-flex full-width mg-md">
          <FormControl variant="filled" style={{ width: '33%', marginRight: 20 }}>
            <AdminPortalTextField
              error={this.state.newTeamNameError}
              id="newTeamName"
              name="newTeamName"
              label="Team Name"
              color="primary"
              InputLabelProps={{ shrink: true }}
              helperText="Enter the team name for the account."
              disabled={isEditing}
              value={newTeamName}
              onChange={this.handleTextFieldsOnChange}
              onBlur={this.handleRequiredFields}
              variant="outlined"
              required
            />
          </FormControl>
          <FormControl variant="filled" style={{ width: '33%', marginRight: 20 }}>
            <AdminPortalTextField
              id="newTeamNick"
              label="Team Nickname"
              color="primary"
              InputLabelProps={{ shrink: true }}
              disabled={isEditing}
              onBlur={this.handleNormalFields}
              value={newTeamNick}
              onChange={this.handleTextFieldsOnChange}
              variant="outlined"
            />
          </FormControl>
          <FormControl variant="filled" style={{ width: '33%', marginRight: 20 }}>
            <AdminPortalTextField
              id="newTeamAbbr"
              label="Team Abbreviation"
              color="primary"
              InputLabelProps={{ shrink: true }}
              disabled={isEditing}
              onBlur={this.handleNormalFields}
              value={newTeamAbbr}
              onChange={this.handleTextFieldsOnChange}
              variant="outlined"
            />
          </FormControl>
        </div>
        <div className="display-flex full-width mg-md">
          <div style={{ width: '33%', marginRight: 20 }}>
            {!isEditing ?
              <div className="display-flex flex-direction-column">
                <span
                  className="mg-sm futura-pt-bold"
                  style={{ fontSize: 13, color: 'rgba(0, 0, 0, 0.35)' }}>Primary Color*</span>
                <div className="display-flex justify-content-center mg-top-sm">
                  <ChromePicker
                    color={`#${newPrimaryColor}`}
                    disableAlpha
                    onChangeComplete={this.handlePrimaryColorChange}/>
                </div>
              </div>
              :
              <div className="display-flex full-width mg-top-sm">
                <AdminPortalTextField
                  id="primary_color"
                  color="primary"
                  disabled={true}
                  label='Primary Color'
                  InputProps={{ startAdornment: <InputAdornment position="start">#</InputAdornment>, }}
                  value={newPrimaryColor}
                  onChange={this.handleTextFieldsOnChange}
                  variant="outlined"
                  fullWidth={true}
                  required
                />
              </div>
            }
          </div>
          <div style={{ width: '33%', marginRight: 20 }}>
            {!isEditing ?
              <div className="display-flex flex-direction-column">
                <span
                  className="mg-sm futura-pt-bold"
                  style={{ fontSize: 13, color: 'rgba(0, 0, 0, 0.35)' }}>Secondary Color*</span>
                <div className="display-flex justify-content-center mg-top-sm">
                  <ChromePicker
                    color={`#${newSecondaryColor}`}
                    disableAlpha
                    onChangeComplete={this.handleSecondaryColorChange}/>
                </div>
              </div>
              :
              <div className="display-flex full-width mg-top-sm">
                <AdminPortalTextField
                  id="secondary_color"
                  color="primary"
                  disabled={true}
                  label='Secondary Color'
                  InputProps={{ startAdornment: <InputAdornment position="start">#</InputAdornment>, }}
                  value={newSecondaryColor}
                  onChange={this.handleTextFieldsOnChange}
                  variant="outlined"
                  fullWidth={true}
                  required
                />
              </div>
            }
          </div>
          <div style={{ width: '33%', marginRight: 20, marginTop: 0 }}>
            <span
              className="mg-sm futura-pt-bold"
              style={{ fontSize: 13, color: 'rgba(0, 0, 0, 0.35)' }}>Team Logo*</span>
            <div className="display-flex flex-direction-column align-items-center justify-content-center">
              <img
                src={newTeamLogo}
                style={{ height: '50%', width: '50%', objectFit: 'scale-down', }}/>
              {!isEditing &&
              <input
                className="btn-primary-admin"
                style={{ backgroundColor: `${accentColor}` }}
                type='file'
                ref={ref => this.fileInput = ref}
                accept="image/x-png,image/gif,image/jpeg"
                onChange={this.handleSelectFile}
              />
              }
            </div>
          </div>
        </div>
        <div className="display-flex full-width mg-md">
          <div style={{ width: '32%', marginRight: 20 }}>
            <AdminPortalDropdown
              options={HEIGHT}
              defaultValue={newHeightUnit}
              value={newHeightUnit}
              label={'Height'}
              helperText={'Enter Height.'}
              id={'newHeightUnit'}
              disabled={isEditing}
              handleSelectedDropdown={this.handleSelectedDropdown}
              error={newHeightUnit === ''}
              isRequired={true}
            />
          </div>
          <div style={{ width: '32%', marginRight: 20 }}>
            <AdminPortalDropdown
              options={WEIGHT}
              defaultValue={newWeightUnit}
              value={newWeightUnit}
              label={'Weight'}
              helperText={'Enter Weight.'}
              id={'newWeightUnit'}
              disabled={isEditing}
              handleSelectedDropdown={this.handleSelectedDropdown}
              error={newWeightUnit === ''}
              isRequired={true}
            />
          </div>
        </div>
        <header
          className="full-width mg-sm mg-top-xl futura-pt-bold"
          style={{ fontSize: 20 }}>Tell Us About Yourself
        </header>
        <div className="display-flex full-width mg-md">
          <div style={{ width: '33%', marginRight: 20 }}>
            <AdminPortalDropdown
              defaultValue={newCountry}
              value={newCountry}
              label={'Country'}
              helperText={'Enter Country.'}
              id={'newCountry'}
              disabled={isEditing}
              handleSelectedDropdown={this.handleSelectedDropdown}
              error={newCountry === ''}
              isRequired={true}
              menuItems={CountryRegionData.map((option) => {
                return <MenuItem key={option[ 0 ]} value={option[ 0 ]}>{option[ 0 ]}</MenuItem>;
              })}
            />
          </div>
          <FormControl variant="filled" style={{ width: '33%', marginRight: 20 }}>
            <AdminPortalTextField
              error={this.state.newStateError}
              id="newState"
              label="State/ Province"
              color="primary"
              InputLabelProps={{ shrink: true }}
              helperText="Enter the State/ Province."
              disabled={newCountry === '' || isEditing}
              value={newState}
              onChange={this.handleTextFieldsOnChange}
              onBlur={this.handleRequiredFields}
              variant="outlined"
              required
            />
          </FormControl>
          <FormControl variant="filled" style={{ width: '33%', marginRight: 20 }}>
            <AdminPortalTextField
              error={this.state.newCityError}
              id="newCity"
              label="City"
              color="primary"
              InputLabelProps={{ shrink: true }}
              helperText="Enter the City."
              disabled={newCountry === '' || isEditing}
              value={newCity}
              onChange={this.handleTextFieldsOnChange}
              onBlur={this.handleRequiredFields}
              variant="outlined"
              required
            />
          </FormControl>
        </div>
        <div className="display-flex full-width mg-md">
          <div style={{ width: '33%', marginRight: 20 }}>
            <AdminPortalDropdown
              options={TEAM_GENDER}
              defaultValue={newTeamGender}
              value={newTeamGender}
              label={'Team Gender'}
              id={'newTeamGender'}
              disabled={isEditing}
              handleSelectedDropdown={this.handleSelectedDropdown}
              error={false}
              isRequired={false}
            />
          </div>
          <div style={{ width: '33%', marginRight: 20 }}>
            <AdminPortalDropdown
              options={TITLE}
              defaultValue={newCoachTitle}
              value={newCoachTitle}
              label={'Title'}
              id={'newCoachTitle'}
              disabled={isEditing}
              handleSelectedDropdown={this.handleSelectedDropdown}
              error={false}
              isRequired={false}
            />
          </div>
          <div style={{ width: '33%', marginRight: 20 }}>
            <AdminPortalDropdown
              options={YEARS_COACHING}
              defaultValue={newCoachingYears}
              value={newCoachingYears}
              label={'Years in Coaching'}
              id={'newCoachingYears'}
              disabled={isEditing}
              handleSelectedDropdown={this.handleSelectedDropdown}
              error={false}
              isRequired={false}
            />
          </div>
        </div>
        <div className="display-flex full-width mg-md mg-top-lg">
          <div style={{ width: '32%', marginRight: 20 }}>
            <AdminPortalDropdown
              options={COACHING_LEVELS}
              defaultValue={newCoachingLevel}
              value={newCoachingLevel}
              label={'Coaching Level'}
              id={'newCoachingLevel'}
              disabled={isEditing}
              handleSelectedDropdown={this.handleSelectedDropdown}
              error={false}
              isRequired={false}
            />
          </div>
          {newCoachingLevel !== '' &&
          <div style={{ width: '32%', marginRight: 20 }}>
            <AdminPortalDropdown
              options={this.fetchCoachingLevelOptions()}
              defaultValue={this.fetchCoachingLevelValue()}
              value={this.fetchCoachingLevelValue()}
              label={newCoachingLevel}
              id={this.fetchCoachingLevelId()}
              disabled={isEditing}
              handleSelectedDropdown={this.handleCoachingLevelSelectedDropdown}
              error={false}
              isRequired={false}
            />
          </div>
          }
        </div>
      </div>
    );
  }
}

export default connect()(ConsumerAccountProperties);